import React from "react";

// Default data (already in new format)
export const defaultPFData = [
  {
    category: "Working Conditions",
    current_filed: "",
    current_pending: "",
    current_remarks: "",
    previous_filed: "",
    previous_pending: "",
    previous_remarks: "",
  },
  {
    category: "Health & Safety",
    current_filed: "",
    current_pending: "",
    current_remarks: "",
    previous_filed: "",
    previous_pending: "",
    previous_remarks: "",
  },
];

const PfGratuityDisputeTable = ({ pfdata = {}, setPfData }) => {
  // ✅ Normalize pfdata to array
  const normalizedPfData = Array.isArray(pfdata)
    ? pfdata
    : Object.entries(pfdata).map(([key, value]) => ({
        category: key,
        current_filed: value?.current?.filed || "",
        current_pending: value?.current?.pending || "",
        current_remarks: value?.current?.remarks || "",
        previous_filed: value?.previous?.filed || "",
        previous_pending: value?.previous?.pending || "",
        previous_remarks: value?.previous?.remarks || "",
      }));

  const handleChange = (index, field, value) => {
    const updated = [...normalizedPfData];
    updated[index][field] = value;
    setPfData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}></th>
            <th colSpan={3} style={headerStyle}>
              FY ____ <br />
              Current Financial Year
            </th>
            <th colSpan={3} style={headerStyle}>
              FY ____ <br />
              Previous Financial Year
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}></th>
            <th style={headerStyle}>Filed during the year</th>
            <th style={headerStyle}>
              Pending resolution at the end of the year
            </th>
            <th style={headerStyle}>Remarks</th>
            <th style={headerStyle}>Filed during the year</th>
            <th style={headerStyle}>
              Pending resolution at the end of the year
            </th>
            <th style={headerStyle}>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {normalizedPfData.map((row, index) => (
            <tr key={row.category}>
              <td style={categoryStyle}>{row.category}</td>

              {/* Current FY */}
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.current_filed}
                  onChange={(e) =>
                    handleChange(index, "current_filed", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.current_pending}
                  onChange={(e) =>
                    handleChange(index, "current_pending", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.current_remarks}
                  onChange={(e) =>
                    handleChange(index, "current_remarks", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>

              {/* Previous FY */}
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.previous_filed}
                  onChange={(e) =>
                    handleChange(index, "previous_filed", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.previous_pending}
                  onChange={(e) =>
                    handleChange(index, "previous_pending", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  value={row.previous_remarks}
                  onChange={(e) =>
                    handleChange(index, "previous_remarks", e.target.value)
                  }
                  placeholder="Details"
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "14.28%",
  wordWrap: "break-word",
};

const categoryStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "left",
  fontWeight: "bold",
  backgroundColor: "#F0E9EC",
  width: "14.28%",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  width: "14.28%",
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "15px",
  textAlign: "center",
  backgroundColor: "white",
  outline: "none",
  boxSizing: "border-box",
};

export default PfGratuityDisputeTable;
